import { render } from "./AddNewPatientOverlay.vue?vue&type=template&id=3cf87968&scoped=true&lang=pug"
import script from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"
export * from "./AddNewPatientOverlay.vue?vue&type=script&lang=js"

import "./AddNewPatientOverlay.vue?vue&type=style&index=0&id=3cf87968&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf87968"]])

export default __exports__